/**
 * QR label dialog for a device. Encodes a deep link to the device card so a
 * physical sticker can be scanned to open the device in the system.
 * Includes a print button (prints just the label).
 */
import React, { useRef } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Box, Typography } from '@mui/material';
import PrintIcon from '@mui/icons-material/Print';

export default function DeviceQrDialog({ open, onClose, device }) {
  const labelRef = useRef(null);
  if (!device) return null;

  const url = `${window.location.origin}/devices/${device.id}`;

  const handlePrint = () => {
    const node = labelRef.current;
    if (!node) return;
    const w = window.open('', '_blank', 'width=420,height=520');
    w.document.write(`
      <html><head><title>QR — ${device.name}</title>
      <style>
        body{font-family:Arial,sans-serif;display:flex;justify-content:center;align-items:center;height:100vh;margin:0}
        .label{border:2px solid #111;border-radius:10px;padding:18px 22px;text-align:center;width:260px}
        .name{font-size:20px;font-weight:700;margin:10px 0 2px}
        .sub{font-size:13px;color:#444}
      </style></head>
      <body>${node.innerHTML}</body></html>`);
    w.document.close();
    w.focus();
    setTimeout(() => { w.print(); w.close(); }, 250);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs">
      <DialogTitle>QR-метка устройства</DialogTitle>
      <DialogContent>
        <Box ref={labelRef} sx={{ textAlign: 'center', p: 2 }}>
          <div className="label" style={{ display: 'inline-block' }}>
            <QRCodeSVG value={url} size={200} level="M" includeMargin />
            <div className="name">{device.name}</div>
            {device.primary_ip && <div className="sub">{device.primary_ip}</div>}
            {device.device_type_name && <div className="sub">{device.device_type_name}</div>}
          </div>
        </Box>
        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', textAlign: 'center' }}>
          Скан открывает карточку: {url}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Закрыть</Button>
        <Button variant="contained" startIcon={<PrintIcon />} onClick={handlePrint}>Печать наклейки</Button>
      </DialogActions>
    </Dialog>
  );
}
